<template>
  <div class="modal-dialog modal-dialog-centered modal-alert modal-narrow">
    <div class="modal-content modal-feedback">
      <div class="modal-header">
                <span v-html="svg('close-gray')"
                      class="pull-right"
                      data-dismiss="modal"
                      aria-hidden="true">
                </span>
        {{ header }}
      </div>
      <div class="modal-body">
        <p class="text-left" :class="{norm:is('message')}">
          {{ message }}
        </p>
        <div class="form-actions" v-if="is('alert')||is('message')">
          <button class="btn btn-primary btn-sm" data-dismiss="modal">Ок</button>
        </div>
        <div class="form-actions" v-if="type == 'confirm'">
          <button type="button" class="btn btn-default btn-sm" data-dismiss="modal">Отмена</button>
          <button class="btn btn-primary btn-sm" @click="$emit('hide', true)">Ок</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import svg from '../svg'

  export default {
    props: {
      type: {
        default: 'alert', // 'alert' || 'confirm' || 'message'
      },
      header: {},
      message: {},
    },
    methods: {
      svg,
      is (type) {
        return type === this.type
      },
    },
  }
</script>

<style lang="scss">
  .modal-alert {
    .btn-primary {
      background-color: #2fb5e9;
      &:hover, &:focus {
        background-color: #0070ba;
      }
    }
  }
  .norm {
    color: #000;
    font-family: "DINPro", "Helvetica Neue", Helvetica, Arial, sans-serif;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/app-alert.vue